import moment from 'moment';

function isValidDate(dateString: string) {
  const date = new Date(dateString);
  return !Number.isNaN(date.getTime());
}

export function getFormattedDate(timestamp: string): string {
  const { locale } = useI18n();
  const updateDate = moment(
    isValidDate(timestamp) ? new Date(timestamp) : +timestamp,
  );
  const now = moment();
  const diffSeconds = now.diff(updateDate, 'seconds');
  const diffMinutes = now.diff(updateDate, 'minutes');
  const diffHours = now.diff(updateDate, 'hours');
  const diffDays = now.diff(updateDate, 'days');

  const rtf = new Intl.RelativeTimeFormat(locale.value, { numeric: 'always' });

  if (diffSeconds < 60) {
    return rtf.format(-diffSeconds, 'second');
  } else if (diffMinutes < 60) {
    return rtf.format(-diffMinutes, 'minute');
  } else if (diffHours < 24) {
    return rtf.format(-diffHours, 'hour');
  } else {
    return rtf.format(-diffDays, 'day');
  }
}
